// SYN-1865 — catálogo de features comerciais (entitlements).
// Espelha `app/entitlements.py` no backend: chave canônica é contrato, o
// rótulo amigável vive no i18n (`features.<chave>`, mesmo desenho de
// `permissionAreas.<área>`). Feature nova nasce nos dois lados.
export const FEATURE_CREATIVE_COMPARISON = 'creative_comparison';
// Tier da comparação (SYN-1865 v1.1): sem esta chave o plano compara até 2
// criativos por vez; com ela, até 4 (o teto da tela). Não implica a base.
export const FEATURE_CREATIVE_COMPARISON_4 = 'creative_comparison_4';
// AOIs manuais (SYN-1865 v1.2): ver, desenhar, renomear e excluir as áreas que
// o próprio usuário traça na imagem. Existe em prod desde sempre, então o
// backfill da v1.2 concede a chave a todo plano existente.
export const FEATURE_MANUAL_AOIS = 'manual_aois';
// AOIs automáticas (SYN-1865 v1.1, semântica estreitada na v1.2): só as áreas
// DETECTADAS pelo pipeline (imagem e vídeo). O pipeline segue detectando para
// todo cliente; sem a chave o painel mostra só a contagem + upsell.
// É também o gate ÚNICO do Gaze (índice do olhar): a SYN-2769 aposentou a chave
// `gaze_distribution`, que todo plano tinha desde 07/10.
export const FEATURE_AUTO_AOIS = 'auto_aois';
export const FEATURE_PPTX_EXPORT = 'pptx_export';
// SYN-2111 — export do relatório como pacote HTML (.zip). INDEPENDENTE de
// `pptx_export`: quem tem só esta exporta HTML e vê o .pptx com cadeado.
export const FEATURE_HTML_EXPORT = 'html_export';
export const FEATURE_SLIDES_EXPORT = 'slides_export';
// Brand DNA (guia da marca por pasta, rotas `/folders/{id}/brand-kit*`). Sem a
// chave o backend recusa toda rota do kit (403 `feature_not_available`) e a
// análise deixa de usar a marca; o SPA mostra a entrada com cadeado e não chama
// a API. Nenhum plano nasce com ela.
// Brand DNA: without the key every brand-kit route is refused and the analysis
// ignores the brand; the SPA shows the entry locked and never calls the API.
export const FEATURE_BRAND_DNA = 'brand_dna';

// Teto da comparação por tier (a tela nunca passa de 4 colunas).
export const COMPARISON_MAX_BASIC = 2;
export const COMPARISON_MAX_EXTENDED = 4;

// Ordem de exibição na UI de admin.
export const FEATURES = [
    FEATURE_CREATIVE_COMPARISON,
    FEATURE_CREATIVE_COMPARISON_4,
    FEATURE_MANUAL_AOIS,
    FEATURE_AUTO_AOIS,
    FEATURE_PPTX_EXPORT,
    FEATURE_HTML_EXPORT,
    FEATURE_SLIDES_EXPORT,
    FEATURE_BRAND_DNA,
];
